import { render, staticRenderFns } from "./OrganAllocationOverAllReport.vue?vue&type=template&id=098144f0"
import script from "./OrganAllocationOverAllReport.vue?vue&type=script&lang=js"
export * from "./OrganAllocationOverAllReport.vue?vue&type=script&lang=js"
import style0 from "./OrganAllocationOverAllReport.vue?vue&type=style&index=0&id=098144f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports